import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { clearAlerts, setErrorAlert } from "../../../store/alert/alertSlice";
import { add_personal_user_userInfo_thunk } from "../../../store/auth/authThunk";
import { LoginFun } from "../../../store/auth/authSlice";
import TypeWriter from "../../../components/OnBoard/Typewriter";
import dizeeLogo from "../../../assets/images/dizee logo.svg";
import styled from "styled-components";
import AccessibilityWidget from "../../../components/AccessibilityWidget";
import { postDataAPI, getDataAPI } from "../../../utils/fetchData";
import { markReleaseAdded } from "../../../utils/onboardingStateMachine";
const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 350px;
  margin: 0 auto;
  padding-left: 35px;
  padding-top: 0;
  overflow: hidden;
  height: 100vh;
  position: relative;
  touch-action: none;
`;

const FormSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 80px;
  gap: 2px;
  margin-top: -40px;
  height: 100%;
  position: relative;
  padding-top: 40px;
`;

const ButtonContainer = styled.div`
  height: 40px;
  margin-top: 40px;
  display: flex;
  align-items: center;
  position: relative;
`;

const ActionButton = styled.div`
  font-size: 12px;
  color: ${props => props.disabled ? 'rgba(255, 255, 255, 0.3)' : 'white'};
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  height: 18px;
  line-height: 18px;
  position: relative;
`;

const Footer = styled.div`
  position: fixed;
  bottom: 27px;
  width: 280px;
`;

const LogoImage = styled.img`
  width: 48px;
  height: auto;
  margin-bottom: 16px;
`;

const FooterText = styled.div`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  max-width: 280px;
  line-height: 1.5;
`;

const Step12 = ({ setStep, setUser, user }) => {
  const [preview, setPreview] = useState(null);
  const [file, setFile] = useState(null);
  const persistedData = localStorage.getItem("persist:root");
  const dispatch = useDispatch();

  useEffect(() => {
    if (user?.avatar) {
      if (typeof user.avatar === "string") {
        setPreview(user.avatar);
      } else if (user.avatar instanceof Blob) {
        setPreview(URL.createObjectURL(user.avatar));
      }
    }
  }, [user?.avatar]);

  useEffect(() => {
    // More comprehensive scroll prevention
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.height = '100%';
    document.body.style.touchAction = 'none'; // Prevent touch scrolling

    return () => {
      document.body.style.overflow = 'unset';
      document.documentElement.style.overflow = 'unset';
      document.body.style.position = 'static';
      document.body.style.width = 'auto';
      document.body.style.height = 'auto';
      document.body.style.touchAction = 'auto';
    };
  }, []);

  const changeAvatar = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setPreview(URL.createObjectURL(selectedFile));
      setUser({ ...user, avatar: selectedFile });
    }
  };

  const handleSubmit = async () => {
    // e.preventDefault(); // Prevent default form submission
    dispatch(clearAlerts());

    try {
    const url = new URL(window.location.href);
    const emailParam = url.searchParams.get("email");
      const userParamString = url.searchParams.get("user");
      
      let userParam = null;
      if (userParamString) {
        try {
          userParam = JSON.parse(userParamString);
        } catch (e) {
          console.error("Failed to parse user parameter:", e);
        }
      }

      // Create a copy of user object to avoid mutation
      const userToSubmit = {
        ...user,
        email: userParam ? userParam.email : emailParam
      };

      // Add some validation for required fields
      if (!userToSubmit.email) {
        dispatch(setErrorAlert("Email is required"));
        return;
      }

      // Ensure we have basic required fields
      if (!userToSubmit.professionRole) {
        dispatch(setErrorAlert("Profession role is required"));
        return;
      }

      // Log the data being sent for debugging
      console.log("Submitting user data:", userToSubmit);

             dispatch(add_personal_user_userInfo_thunk(userToSubmit)).then(async (res) => {
         console.log("API response:", res);
        if (res?.payload?.status === 200) {
           // Set user as logged in
           dispatch(LoginFun(true));
           
          // Determine redirect URL first
          let redirectUrl = "/more";
           if (userToSubmit?.professionRole === 'artist') {
            redirectUrl = "/";
           } else if (['manager', 'agent', 'label', 'publisher', 'business-manager'].includes(userToSubmit?.professionRole)) {
            redirectUrl = "/team-member-dashboard";
          }
          
          // Save pending catalog releases if any
          const pendingReleases = localStorage.getItem('pendingCatalogReleases');
          if (pendingReleases) {
            try {
              console.log('📚 Saving pending catalog releases after authentication...');
              const releases = JSON.parse(pendingReleases);
              const token = JSON.parse(localStorage.getItem('dizeeToken'));
              
              // Get existing catalog to check for duplicates
              let existingCatalog = [];
              try {
                const catalogResponse = await getDataAPI('user/getCatalog', token);
                if (catalogResponse?.data?.status === 200 && catalogResponse?.data?.data) {
                  existingCatalog = Array.isArray(catalogResponse.data.data) 
                    ? catalogResponse.data.data 
                    : catalogResponse.data.data.data;
                }
              } catch (catalogError) {
                console.warn('Could not fetch existing catalog:', catalogError);
              }

              // Filter out duplicates
              const normalize = (str) => str ? str.toLowerCase().trim() : '';
              const newReleases = releases.filter(newRelease => {
                return !existingCatalog.some(existingTrack => {
                  const newSongName = normalize(newRelease.song_title);
                  const newArtistName = normalize(newRelease.primary_artist);
                  const existingSongName = normalize(existingTrack.song_title || existingTrack.song_name || existingTrack.title);
                  const existingArtistName = normalize(existingTrack.primary_artist || existingTrack.artist_name || existingTrack.artist);
                  return newSongName && newArtistName && 
                         newSongName === existingSongName && 
                         newArtistName === existingArtistName;
                });
              });

              if (newReleases.length > 0) {
                const response = await postDataAPI('user/saveCatalog', {
                  data: newReleases
                }, token);

                if (response.data.status === 200) {
                  console.log(`✅ Successfully saved ${newReleases.length} pending release(s) to catalog`);
                  markReleaseAdded();
                  
                  // Trigger reminder system update
                  localStorage.setItem('catalog_updated', Date.now().toString());
                  window.dispatchEvent(new CustomEvent('localStorageUpdate', {
                    detail: {
                      key: 'catalog_updated',
                      newValue: Date.now().toString()
                    }
                  }));
                }
              }
              
              // Clear pending releases
              localStorage.removeItem('pendingCatalogReleases');
            } catch (err) {
              console.error('⚠️ Failed to save pending catalog releases:', err);
              // Don't block navigation if this fails
            }
          }
          
          // Auto-import Bandsintown shows if artist name was captured during onboarding
          const pendingArtistName = localStorage.getItem('pendingBandsintownImport');
          if (pendingArtistName) {
            console.log('🎵 Starting Bandsintown auto-import for:', pendingArtistName);
            
            // Start import but don't wait for completion - navigate after a short delay
            const importPromise = (async () => {
              try {
                const { importBandsintownViaAI } = await import('../../../utils/bandsintownAgent');
                const result = await importBandsintownViaAI(pendingArtistName);
                
                if (result.success && result.savedCount > 0) {
                  console.log(`✅ Successfully imported ${result.savedCount} shows from Bandsintown`);
                  localStorage.setItem('bandsintownImportSuccess', result.savedCount.toString());
                } else {
                  console.log('⚠️ Bandsintown import completed but no shows imported:', result.error);
                }
              } catch (err) {
                console.error('⚠️ Bandsintown import failed:', err);
              } finally {
                localStorage.removeItem('pendingBandsintownImport');
              }
            })();
            
            // Wait 2 seconds to let import start, then navigate
            // This gives time for the import to complete or at least start
            console.log('⏳ Waiting briefly for import to initialize...');
            setTimeout(() => {
              console.log('🚀 Navigating to:', redirectUrl);
              window.location.href = redirectUrl;
            }, 2000);
           } else {
            // No import needed, navigate immediately
            console.log('🚀 Navigating to:', redirectUrl);
            window.location.href = redirectUrl;
           }
         } else {
           // Handle API errors more gracefully
           const errorMsg = res?.payload?.message || res?.error?.message || 'Failed to save user information';
           dispatch(setErrorAlert(errorMsg));
         }
       }).catch((error) => {
         console.error("API call failed:", error);
         dispatch(setErrorAlert("Failed to save user information. Please try again."));
       });
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      dispatch(setErrorAlert("An error occurred while processing your information"));
    }
  };

  const handleNext = async () => {
    if (user.professionRole === "artist" || user.professionRole === "manager") {
      // For artists and managers, complete the onboarding here instead of going to step 13
      handleSubmit();
    } else {
      handleSubmit(); // Ensure handleSubmit is called correctly
    }
  };

  // Handle key press events
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleNext(); // Call your next step function
    }
  };

  return (
    <Container>
      <FormSection>
        <div className="w-[200px]">
          <div
            className="mb-[68px] cursor-pointer"
            onClick={() => document.getElementById("avatar").click()}
          >
            <TypeWriter
              key={preview ? "change" : "upload"}
              text={preview ? "Change cover image" : "Upload a cover image"}
              speed={45}
            />
          </div>

          <input
            type="file"
            className="hidden"
            id="avatar"
            onChange={changeAvatar}
          />

          {preview && (
            <div className="profile-picture mb-9 min-h-[100px]">
              <div className="avatar">
                <img
                  src={preview}
                  className="h-[80px] w-[80px]"
                  alt="avatar"
                  style={{
                    objectFit: 'cover',
                    borderRadius: '4px'
                  }}
                />
              </div>
            </div>
          )}

          <ButtonContainer>
            <ActionButton
              disabled={!(file || user?.avatar)}
              onClick={() => {
                if (file || user?.avatar) {
                  handleNext();
                }
              }}
              className="mr-[43px]"
            >
              Next
            </ActionButton>

            <ActionButton
              onClick={() => {
                setStep(22);
              }}
            >
              Go back
            </ActionButton>
          </ButtonContainer>
        </div>
      </FormSection>

      <Footer>
        <LogoImage src={dizeeLogo} alt="DIZEE" />
        <FooterText>
          Upload a profile picture that represents you or your brand. This will be displayed on your profile page.
        </FooterText>
      </Footer>
      <AccessibilityWidget />
    </Container>
  );
};

export default Step12;
